import { iconNames } from '@zapier/design-system';
export const ICON_NAMES = Object.keys(iconNames).reduce((acc, key) => {
    return Object.assign(Object.assign({}, acc), { [key]: key });
}, {});
//# sourceMappingURL=icons.js.map